import styled, { css } from 'styled-components';

export const Badge = styled.span`
    align-items: center;
    align-self: flex-start;
    border-radius: 50%;
    color: var(--gray800);
    display: inline-flex;
    font-size: 16px;
    font-weight: 600;
    height: 32px;
    justify-content: center;
    margin-left: -1px;
    min-height: 32px;
    min-width: 32px;
    position: absolute;
    text-transform: uppercase;
    width: 32px;

    color: var(--color-white);

    ${(props) =>
        props.type === 'error' &&
        css`
            ${props.useIconsForValidation ? 'color:' : 'background-color:'} var(--color-error-default);
        `}
    ${(props) =>
        props.type === 'success' &&
        css`
            ${props.useIconsForValidation ? 'color:' : 'background-color:'} var(--color-success-default);
        `}
    ${(props) =>
        props.type === 'warning' &&
        css`
            ${props.useIconsForValidation ? 'color:' : 'background-color:'} var(--color-warning-default);
        `}
    ${(props) =>
        props.type === 'missing' &&
        css`
            ${props.useIconsForValidation ? 'color:' : 'background-color:'} var(--gray700);
        `}
`;

export const Container = styled.span`
    background-color: var(--color-white);
    border-radius: 16px;
    border: 1px solid var(--blue500);
    box-sizing: border-box;
    color: var(--gray800);
    cursor: pointer;
    justify-content: center;
    line-height: 24px;
    margin: 2px;
    max-width: 100%;
    min-height: 32px;
    min-width: ${(props) => (props.hasBadgeContent ? '64px' : '44px')};
    outline: none;

    img {
        margin: 0 4px;
        vertical-align: middle;
    }

    ${(props) =>
        props.disabled &&
        css`
            color: var(--gray700);
            border: 1px solid var(--gray200);
            background-color: var(--color-white);
            opacity: 50%;
            box-shadow: none;

            &:hover {
                cursor: default;
            }
        `}
`;

const Fade = styled.span`
    background-size: cover;
    min-height: calc(100% - 6px);
    position: absolute;
    top: 3px;
    width: 56px;
    pointer-events: none;
    box-sizing: border-box;
`;

export const LeftFade = styled(Fade)`
    border-radius: 16px 0 0 16px;
    left: 3px;
    background: transparent;

    ${(props) =>
        props.isScrolling &&
        css`
            background: linear-gradient(90deg, white, white, rgba(255, 255, 255, 0.5), transparent);
        `}

    ${(props) =>
        props.isScrolling &&
        props.type === 'selected' &&
        css`
            background: linear-gradient(90deg, var(--blue50), var(--blue50), rgba(225, 240, 255, 0.5), transparent);
        `}
`;

export const RightFade = styled(Fade)`
    border-radius: 0 16px 16px 0;
    right: 3px;
    background: transparent;

    ${(props) =>
        props.overflowing &&
        css`
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), white, white);
        `};

    ${(props) =>
        props.overflowing &&
        props.type === 'selected' &&
        css`
            background: linear-gradient(90deg, transparent, rgba(225, 240, 255, 0.5), var(--blue50), var(--blue50));
        `}

    ${(props) =>
        props.overflowing &&
        props.type === 'validated' &&
        props.validationType === 'missing' &&
        css`
            background: linear-gradient(90deg, transparent, rgba(246, 246, 246, 0.5), var(--gray50), var(--gray50));
        `}

        ${(props) =>
        props.overflowing &&
        props.type === 'validated' &&
        props.validationType === 'warning' &&
        css`
            background: linear-gradient(90deg, transparent, rgba(251, 244, 230, 0.5), var(--yellow50), var(--yellow50));
        `}


        ${(props) =>
        props.overflowing &&
        props.type === 'validated' &&
        props.validationType === 'success' &&
        css`
            background: linear-gradient(90deg, transparent, rgba(239, 252, 224, 0.5), var(--green50), var(--green50));
        `}


        ${(props) =>
        props.overflowing &&
        props.type === 'validated' &&
        props.validationType === 'error' &&
        css`
            background: linear-gradient(90deg, transparent, rgba(253, 239, 238, 0.5), var(--red50), var(--red50));
        `}
`;

export const Value = styled.div`
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 4px 8px;
`;

export const Wrapper = styled.div`
    position: relative;
    display: inline-flex;
    max-width: 100%;
    max-height: 100%;
`;
